package com.techspiration.webuserapp

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import kotlinx.browser.window

/**
 * Compose HTML'e uygun, hafif navigator — `core:navigation.Navigator`'ın `goto`/backstack fikrinin
 * karşılığı, ama Compose runtime state ile (gerçek DOM üzerinde).
 *
 * URL'e bağlıdır (`window.location.pathname` + `history.pushState`): Apple review gibi dışarıdan
 * doğrudan `/privacy` veya `/terms` linkine tıklayan biri, SPA'nın ana sayfaya değil DOĞRU ekrana
 * düşmesini bekler — bu yüzden ilk state URL'den okunur, geri/ileri (`popstate`) dinlenir.
 */
class UserNavigator {
    private val _current: MutableState<UserRoute> = mutableStateOf(routeForPath(window.location.pathname))

    val current: UserRoute
        get() = _current.value

    init {
        window.addEventListener("popstate", { _: org.w3c.dom.events.Event ->
            _current.value = routeForPath(window.location.pathname)
        })
    }

    fun goto(route: UserRoute) {
        _current.value = route
        window.history.pushState(null, "", route.path())
    }
}
